export default __webpack_public_path__ + "media/img/filetypes/pdf-96b612ffd3de402279cf1eef891a948f.svg";